<template>
  <lazy-div>
    <message :messages="messages"></message>
    <v-container fluid grid-list-sm>
      <v-flex xs12 order-xs2 order-lg1>
        <v-card>
          <v-flex lg12 md12 xs12>
            <v-card>
              <v-toolbar dense color="grey lighten-4" flat>
                <v-icon>mdi-format-list-bulleted</v-icon>
                <v-toolbar-title class="body-2" v-if="$vuetify.breakpoint.smAndUp">Service Provider</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark small color="primary" v-on="on" @click.native="addServicer">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Add New Service Provider</span>
                </v-tooltip>
                <v-btn icon @click.native="servicerLayer = !servicerLayer">
                  <v-icon v-if="servicerLayer">mdi-chevron-down</v-icon>
                  <v-icon v-else>mdi-chevron-up</v-icon>
                </v-btn>
              </v-toolbar>
              <v-expand-transition>
                <v-data-table class="elevation-1" :items="commonInfo.servicers" :headers="serviceHeaders" v-if="servicerLayer">
                  <template v-slot:item="row"
                    ><tr>
                      <td>{{ getClaimantDesc(row.item.clmtNo) }}</td>
                      <td>{{ row.item.clmItem }}</td>
                      <td>{{ row.item.interGrpName }}</td>
                      <td>{{ row.item.interName }}</td>
                      <!-- <td>{{ getCurrency(row.item.curr).label }}</td> -->
                      <td>{{ row.item.curr + ' - ' + row.item.currDesc }}</td>
                      <td class="text-right">{{ formatNumber(Number(row.item.amt), 2) }}</td>
                      <td class="text-right">{{ formatNumber(Number(row.item.locAmt), 2) }}</td>
                      <td class="table-action-header">
                        <table-action
                          :rowData="row"
                          review
                          @review="doAdjustServicer"
                          :query="false"
                          remove
                          @remove="doPromptRemoveServicer"
                        ></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-expand-transition>
              <v-spacer class="mt-1"></v-spacer>
              <v-toolbar dense color="grey lighten-4" flat>
                <v-icon>mdi-view-list</v-icon>
                <v-toolbar-title class="body-2" v-if="$vuetify.breakpoint.mdAndUp">Reserve</v-toolbar-title>
                <v-spacer></v-spacer>
                <div style="margin-top: 15px; margin-right: 15px">
                  <v-switch v-model="reserveCurr" label="Reserve Currency"></v-switch>
                </div>
                <!-- <v-btn color="primary" @click.native="toggleCurr">
                    <span v-if="displayCurr==='res' && $vuetify.breakpoint.mdAndUp">Show in Base Curr </span>
                    <span v-if="displayCurr==='base' && $vuetify.breakpoint.mdAndUp">Show in Res Curr </span>
                    <v-icon>mdi-currency-usd</v-icon>
                </v-btn> -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark small color="primary" v-on="on" @click.native="addReserve" :disabled="!usrClmLim">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Add New Reserve</span>
                </v-tooltip>
                <v-btn icon @click.native="reserveLayer = !reserveLayer">
                  <v-icon v-if="reserveLayer">mdi-chevron-down</v-icon>
                  <v-icon v-else>mdi-chevron-up</v-icon>
                </v-btn>
              </v-toolbar>
              <v-expand-transition>
                <v-data-table class="elevation-1" :items="displayAccumRes" :headers="activeHeaders" :key="tableKey">
                  <template v-slot:item="row">
                    <tr
                      :class="{ activeRow: selectedRecord == row.item.clmtNo + '-' + row.item.clmItem + '-' + row.item.clmResCat }"
                      @click="activateRow(row)"
                    >
                      <td>{{ getClaimantDesc(row.item.clmtNo) }}</td>
                      <td>{{ row.item.clmItem }}</td>
                      <!-- <td>{{ getParamReserve(row.item.clmResCat).label }}</td> -->
                      <td>{{ row.item.clmResCat + ' - ' + row.item.clmResCatDesc }}</td>
                      <td>{{ row.item.status }}</td>
                      <td class="text-right" v-if="displayCurr === 'res'">
                        {{ commonInfo.resCurr }} {{ formatDisplayNumber(row.item.clmResOS, 2) }}
                      </td>
                      <td class="text-right" v-if="displayCurr === 'res'">
                        {{ commonInfo.resCurr }} {{ formatDisplayNumber(row.item.plannedRes, 2) }}
                      </td>
                      <td class="text-right" v-if="displayCurr === 'res'">{{ commonInfo.resCurr }} {{ formatDisplayNumber(row.item.paidRes, 2) }}</td>
                      <td class="text-right" v-if="displayCurr === 'base'">{{ formatDisplayNumber(row.item.clmResOSLoc, 2) }}</td>
                      <td class="text-right" v-if="displayCurr === 'base'">{{ formatDisplayNumber(row.item.plannedLoc, 2) }}</td>
                      <td class="text-right" v-if="displayCurr === 'base'">{{ formatDisplayNumber(row.item.paidLoc, 2) }}</td>
                      <td class="table-action-header" v-if="usrClmLim" >
                        <table-action :rowData="row" review @review="doAdjustReserve" :review-text="'Adjust Reserve'"/>
                      </td>
                    </tr>
                  </template>
                  <template slot="footer">
                    <v-simple-table>
                      <thead>
                        <tr style="visibility: collapse">
                          <th class="text-left" style="padding: 0px 16px">Claimantbbbb</th>
                          <th class="text-left" style="padding: 0px 16px">Item No.bbbb</th>
                          <th class="text-left" style="padding: 0px 16px">Reserve Categorybbbb</th>
                          <th class="text-right" v-if="displayCurr === 'base'" style="padding: 0px 16px; max-width:195px">
                            Outstanding Reserve (Local)bbb
                          </th>
                          <th class="text-right" v-if="displayCurr === 'base'" style="padding: 0px 16px; max-width:210px">
                            Planned to Pay (Local)bbb
                          </th>
                          <th class="text-right" v-if="displayCurr === 'base'" style="padding: 0px 16px; max-width:195px">Already Paid (Local)bbb</th>
                          <th class="text-right" v-if="displayCurr === 'res'" style="padding: 0px 16px; max-width:195px">Outstanding Reserve bbb</th>
                          <th class="text-right" v-if="displayCurr === 'res'" style="padding: 0px 16px; max-width:210px">Planned to Pay bbb</th>
                          <th class="text-right" v-if="displayCurr === 'res'" style="padding: 0px 16px; max-width:195px">Already Paid bbb</th>
                          <th class="text-right" style="padding: 0px 16px">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-left" />
                          <td class="text-left" />
                          <td class="text-right">
                            <strong>Total:</strong>
                          </td>
                          <td class="text-right" v-if="displayCurr === 'res'" style="max-width:195px">
                            {{ commonInfo.resCurr }} {{ formatDisplayNumber(commonInfo.totAccumRes, 2) }}
                          </td>
                          <td class="text-right" v-if="displayCurr === 'res'" style="max-width:210px">
                            {{ commonInfo.resCurr }} {{ formatDisplayNumber(commonInfo.totPlannedRes, 2) }}
                          </td>
                          <td class="text-right" v-if="displayCurr === 'res'" style="max-width:195px">
                            {{ commonInfo.resCurr }} {{ formatDisplayNumber(commonInfo.totPaidRes, 2) }}
                          </td>
                          <td class="text-right" v-if="displayCurr === 'base'" style="max-width:250px">
                            {{ formatDisplayNumber(commonInfo.totAccumResLoc, 2) }}
                          </td>
                          <td class="text-right" v-if="displayCurr === 'base'" style="max-width:210px">
                            {{ formatDisplayNumber(commonInfo.totPlannedLoc, 2) }}
                          </td>
                          <td class="text-right" v-if="displayCurr === 'base'" style="max-width:195px">{{ formatDisplayNumber(commonInfo.totPaidLoc, 2) }}</td>
                          <td class="text-right" style="width:88px"></td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </template>
                </v-data-table>
              </v-expand-transition>
              <v-spacer class="mt-2"></v-spacer>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-spacer class="mt-2"></v-spacer>
      </v-flex>
      <v-flex xs12>
        <v-btn class="mr-2" color="secondary" type="submit" @click.prevent="doBack" :loading="loading">
          <span>Back</span>
          <v-icon right dark>mdi-arrow-left-bold-box</v-icon>
        </v-btn>
        <v-btn class="mr-2" color="error" @click.native="doExit" :loading="loading">
          <span>Exit</span>
          <v-icon right>mdi-exit-to-app</v-icon>
        </v-btn>
        <v-btn class="mr-2" color="primary" dark @click="doPrintClaimFaceSheet" :loading="loading">
          Print Claim Face Sheet
          <v-icon dark right>mdi-printer</v-icon>
        </v-btn>
        <v-btn class="mr-2" color="primary" type="submit" @click.prevent="doQuickPay" :loading="loading" :disabled="!usrClmLim">
          <span>Proceed</span>
          <v-icon right>mdi-arrow-right-bold-box</v-icon>
        </v-btn>
      </v-flex>
    </v-container>
    <v-dialog v-model="servicerDialog" max-width="600px" :persistent="true">
      <v-card>
        <v-toolbar v-if="newServicer" dense color="grey lighten-3" flat>
          <v-icon>mdi-plus</v-icon>
          <v-toolbar-title>Create New Service Provider</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar v-if="!newServicer" dense color="grey lighten-3" flat>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title>Edit Service Provider</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <form>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <!-- <v-autocomplete
                  :disabled="!newServicer"
                  :items="claimItemList"
                  v-validate="'required'"
                  v-model="svcClmtAndItem"
                  :label="labels.clmtAndItem"
                  clearable
                  item-text="label"
                  item-value="value"
                  data-vv-name="svcClmtAndItem"
                  :data-vv-as="labels.clmtAndItem"
                  :error-messages="errors.collect('svcClmtAndItem')"
                ></v-autocomplete> -->
                <v-text-field
                  :disabled="!newServicer"
                  :label="labels.clmtAndItem"
                  v-model="svcClmtAndItemDesc"
                  v-validate="'required'"
                  :error-messages="errors.collect('svcClmtAndItem')"
                  data-vv-name="svcClmtAndItem"
                  :data-vv-as="labels.clmtAndItem"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('svcClaimItem')"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="newServicer">
                <!-- <v-autocomplete
                  data-vv-scope="servicer"
                  :items="addableServicerGrps"
                  v-validate="'required'"
                  v-model="servicer.interGrp"
                  :label="labels.interGrp"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('servicer.interGrp')"
                  data-vv-name="servicer.interGrp"
                  :data-vv-as="labels.interGrp"
                  @change="servicer.inter = undefined"
                ></v-autocomplete> -->
                <v-text-field
                  disabled
                  :label="labels.interGrp"
                  v-model="servicer.interGrp"
                  v-validate="'required'"
                  :error-messages="errors.collect('servicer.interGrp')"
                  data-vv-name="servicer.interGrp"
                  :data-vv-as="labels.interGrp"
                  readonly
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.interGrp }}</v-subheader>
                <div class="subheading">{{ getParamServicerGrp(servicer.interGrp).thirdValue }}</div>
              </v-flex> -->
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.interGrp }}</v-subheader>
                <div class="subheading">{{ interGrpName }}</div>
              </v-flex>
              <v-flex xs12 v-if="newServicer">
                <!-- <v-autocomplete
                  data-vv-scope="servicer"
                  :items="addableServicers"
                  v-validate="'required'"
                  v-model="servicer.inter"
                  :label="labels.inter"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('servicer.inter')"
                  data-vv-name="servicer.inter"
                  :data-vv-as="labels.inter"
                ></v-autocomplete> -->
                <v-text-field
                  :label="labels.inter"
                  v-model="servicer.inter"
                  v-validate="'required'"
                  :error-messages="errors.collect('servicer.inter')"
                  data-vv-name="servicer.inter"
                  :data-vv-as="labels.inter"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('inter')"
                  readonly
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.inter }}</v-subheader>
                <div class="subheading">{{ getParamServicer(servicer.inter).label }}</div>
              </v-flex> -->
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.inter }}</v-subheader>
                <div class="subheading">{{ interName }}</div>
              </v-flex>
              <v-flex xs12>
                <!-- <v-autocomplete
                  data-vv-scope="servicer"
                  :items="currencyList"
                  v-validate="'required'"
                  v-model="servicer.curr"
                  :label="labels.curr"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('servicer.curr')"
                  data-vv-name="servicer.curr"
                  :data-vv-as="labels.curr"
                ></v-autocomplete> -->
                <v-text-field
                  :label="labels.curr"
                  v-model="servicer.curr"
                  v-validate="'required'"
                  :error-messages="errors.collect('servicer.curr')"
                  data-vv-name="servicer.curr"
                  :data-vv-as="labels.curr"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('curr')"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  data-vv-scope="servicer"
                  type="tel"
                  v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                  v-validate="'required|max:20'"
                  v-model="servicer.amt"
                  :label="labels.amt"
                  :error-messages="errors.collect('servicer.amt')"
                  data-vv-name="amt"
                  :data-vv-as="labels.amt"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="closeServicer">Cancel</v-btn>
            <v-btn color="primary" text @click.native="saveServicer">Save</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="reserveDialog" max-width="700px" :persistent="true">
      <v-card>
        <v-toolbar v-if="!newReserve" dense color="grey lighten-3" flat>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title>Edit Reserve </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="newReserve" dense color="grey lighten-3" flat>
          <v-icon>mdi-plus</v-icon>
          <v-toolbar-title>Create New Reserve</v-toolbar-title>
        </v-toolbar>
        <form>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <!-- <v-autocomplete
                  :items="claimItemList"
                  v-validate="'required'"
                  v-model="clmtAndItem"
                  :label="labels.clmtAndItem"
                  clearable
                  item-text="label"
                  item-value="value"
                  data-vv-name="clmtAndItem"
                  :data-vv-as="labels.clmtAndItem"
                  :error-messages="errors.collect('clmtAndItem')"
                ></v-autocomplete> -->
                <v-text-field
                  :label="labels.clmtAndItem"
                  v-model="clmtAndItemDesc"
                  v-validate="'required'"
                  :error-messages="errors.collect('clmtAndItem')"
                  data-vv-name="clmtAndItem"
                  :data-vv-as="labels.clmtAndItem"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('claimItem')"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="newReserve">
                <v-text-field
                  :label="labels.clmResCat"
                  v-model="reserve.clmResCat"
                  v-validate="'required'"
                  :error-messages="errors.collect('reserve.clmResCat')"
                  data-vv-name="reserve.clmResCat"
                  :data-vv-as="labels.clmResCat"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('clmRes')"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.clmResCat }}</v-subheader>
                <!-- <div class="queryValue">{{ getParamReserve(reserve.clmResCat).label }}</div> -->
                <div class="queryValue">{{ reserve.clmResCat + ' - ' + clmResCatDesc }}</div>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  data-vv-scope="itemReserve"
                  type="tel"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  v-validate="{
                    required: true,
                    mask_decimal: 2,
                    res_amt_pne: getParamReserve(reserve.clmResCat).resAmtPNE,
                    not_zero: this.newClm ? true : false
                  }"
                  v-model="reserve.reserve"
                  :label="labels.reserve"
                  :error-messages="errors.collect('itemReserve.reserve')"
                  data-vv-name="reserve"
                  :data-vv-as="labels.reserve"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="closeReserve">Cancel</v-btn>
            <v-btn color="primary" text @click.native="saveReserve">Save</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="reserveListDialog" max-width="1000px" transition="dialog-transition" scrollable>
      <reserve-track-list @close="reserveListDialog = false"></reserve-track-list>
    </v-dialog>
    <confirm v-model="promptRemoveServicer" @ok="doRemoveServicer">
      <!-- This Servicer Provider: <br /><strong>{{ getParamServicer(servicerRemove.inter).label }}</strong
      ><br /> -->
      This Servicer Provider: <br /><strong>{{ this.servicerRemove.inter }}</strong
      ><br />
      under this claim item will be removed.
    </confirm>
    <confirm v-model="promptRemoveReserve" @ok="doRemoveReserve">
      <!-- Reserve in this category: <br /><strong>{{ getParamReserve(reserveRemove.clmResCat).label }}</strong
      ><br /> -->
      Reserve in this category: <br /><strong>{{ 'jjkk' }}</strong
      ><br />
      under this claim item will be removed.
    </confirm>
    <confirm-auth v-model="promptAuth" @ok="doAuthPendClmRes('Approve')" @cancel="doAuthPendClmRes('Reject')" @close="closePopOut" yes-label="Yes" no-label="No" cancel-label="Cancel"><div style="white-space: pre-line">{{ authTxt }}</div></confirm-auth>
    <confirm-auth v-model="promptAdjResTxt" @ok="doExitClaim" yes-label="Exit Claim" @cancel="promptAdjResTxt = false" :info="true">{{ adjResTxt }}</confirm-auth>
    <confirm-auth v-model="promptAuthApproveTxt" @ok="promptAuthApproveTxt === false" yes-label="Cancel" :info="true">{{ authApproveTxt }}</confirm-auth>
    <confirm-auth v-model="promptPendingPayment" yes-label="Ok" :info="true">{{ promptPendingPaymentTxt }}</confirm-auth>
    <confirm-auth v-model="promptPendingReserve" yes-label="Ok" :info="true">{{ promptPendingReserveTxt }}</confirm-auth>
    <confirm-auth v-model="promptEditOrgRes" yes-label="Ok" :info="true">{{ promptEditOrgResTxt }}</confirm-auth>
    <warning v-model="promptPrntClmFcSht" :info="true">
      {{ msgPrntClmFcSht }}
    </warning>
    <!-- ClaimItem -->
    <v-dialog v-model="showClaimItemHelpList" width="1080px">
      <claim-item-help-list
        :claimNo="commonInfo.clmNo"
        @close="showClaimItemHelpList = false"
        @assign-claimItem-info="doAssign('claimItem', $event)"
      ></claim-item-help-list>
    </v-dialog>
    <!-- ServicerGroup -->
    <v-dialog v-model="showServicerGroupHelpList" width="1080px">
      <servicer-group-help-list
        @close="showServicerGroupHelpList = false"
        @assign-servicerGroup="doAssign('interGrp', $event)"
      ></servicer-group-help-list>
    </v-dialog>
    <!-- Servicer -->
    <v-dialog v-model="showServicerHelpList" width="1080px">
      <servicer-help-list @close="showServicerHelpList = false" @assign-servicer="doAssign('inter', $event)"></servicer-help-list>
    </v-dialog>
    <!-- ClaimReserve -->
    <v-dialog v-model="showClaimReserveHelpList" width="1080px">
      <claim-reserve-help-list
        :busCls="commonInfo.busCls"
        @close="showClaimReserveHelpList = false"
        @assign-reserve="doAssign('clmRes', $event)"
      ></claim-reserve-help-list>
    </v-dialog>
    <!-- Currency -->
    <v-dialog v-model="showCurrHelpList" width="1080px">
      <currency-help-list @close="showCurrHelpList = false" @assign-currency-info="doAssign('curr', $event)"></currency-help-list>
    </v-dialog>
    <v-dialog v-model="promptCaptureAuth" width="500px" persistent>
      <CaptureAuth @close="doCloseEnterPassword" @updateRecord="updateAfterAuth1" @init="doInit" @cancel="doCloseEnterPassword" :clmNo="this.commonInfo.clmNo" :clmStat="this.commonInfo.clmStat" :screen="true" :del="false"></CaptureAuth>
    </v-dialog>
    <v-dialog v-model="promptCaptureAuthDel" width="500px" persistent>
      <CaptureAuth @close="doCloseEnterPassword" @updateRecord="doDelPendClmRes" @init="doInit" @cancel="doCloseEnterPassword" :clmNo="this.commonInfo.clmNo" :clmStat="this.commonInfo.clmStat" :screen="true" :del="true"></CaptureAuth>
    </v-dialog>
  </lazy-div>
</template>

<script>
import {
  CLAIMS_LIFECYCLE,
  CLAIMS_CLAIMDETAIL_CLAIMITEM,
  CLAIMS_CLAIMDETAIL_CLAIMANT,
  CLAIMS_CLAIMDETAIL_RESERVES,
  CLAIMS_CLAIMPAYMENT_SELECTEDRESERVES
} from '@/store/types'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import ReserveTrackList from '@/components/core/claimManagement/reserveSub/ReserveTrackList'
// import clone from 'clone'
import { removeFormatNumber, formatDisplayNumber } from '@/utils/number'
import { expandURI } from '@/utils/ajax'
import ClaimItemHelpList from '@/components/core/claimManagement/helpList/ClaimItemHelpList'
import ServicerGroupHelpList from '@/components/core/claimManagement/helpList/ServicerGroupHelpList'
import ServicerHelpList from '@/components/core/claimManagement/helpList/ServicerHelpList'
import ClaimReserveHelpList from '@/components/core/claimManagement/helpList/ClaimReserveHelpList'
import CurrencyHelpList from '@/components/core/common/dialog/CurrencyHelpList'
import ConfirmAuth from '@/components/core/claimManagement/ConfirmAuth'
import CaptureAuth from './CaptureAuth'
export default {
  data() {
    return {
      promptPrntClmFcSht: false,
      msgPrntClmFcSht: '',
      selectedRecord: 0,
      claimantList: [],
      selectedRow: {},
      // Panel Controller
      servicerLayer: true,
      reserveLayer: true,
      // Dialog Controller
      servicerDialog: false,
      reserveDialog: false,
      reserveListDialog: false,
      // New Controller
      newServicer: false,
      newReserve: false,
      promptRemoveServicer: false,
      promptRemoveReserve: false,
      servicerRemove: {},
      reserveRemove: {},
      selectedServicer: {
        inter: undefined,
        interGrp: undefined,
        curr: undefined
      },
      selectedReserve: {
        clmResCat: undefined
      },
      reserveCurr: false,
      displayCurr: 'base',
      labels: {
        clmReserves: 'Claim Service Providers and Reserves',
        interGrp: 'Servicer Group*',
        inter: 'Servicer*',
        curr: 'Currency*',
        amt: 'Amount*',
        locAmt: 'Local Amount*',
        clmResCat: 'Reserve Category*',
        reserve: 'Reserve Amount*',
        reserveLoc: 'Local Reserve Amount',
        clmtAndItem: 'Claimant / Item No.*'
      },
      servicer: {
        interGrp: undefined,
        inter: undefined,
        curr: undefined,
        amt: undefined,
        locAmt: undefined
      },
      reserve: {
        clmResCat: undefined,
        reserve: undefined,
        reserveLoc: undefined,
        tranDate: undefined,
        totRes: undefined
      },
      serviceHeaders: [
        { text: 'Claimant', align: 'left', value: 'clmtNo' },
        { text: 'Item No.', align: 'left', value: 'clmItem' },
        { text: 'Servicer Group', align: 'left', value: 'interGrp' },
        { text: 'Servicer', align: 'left', value: 'interName' },
        { text: 'Currency', align: 'left', value: 'curr' },
        { text: 'Amount', align: 'right', value: 'amt' },
        { text: 'Amount (Local)', align: 'right', value: 'locAmt' },
        TableConst.tableActionHeader
      ],
      reserveHeaders: {
        res: [
          { text: 'Claimant', align: 'left', value: 'clmtNo' },
          { text: 'Item No.', align: 'left', value: 'clmItem' },
          { text: 'Reserve Category', align: 'left', value: 'clmResCat' },
          { text: 'Status', align: 'left', value: 'status' },
          { text: 'Outstanding Reserve', align: 'right', value: 'clmResOS' },
          { text: 'Planned to Pay', align: 'right', value: 'planned' },
          { text: 'Already Paid', align: 'right', value: 'paid' },
          TableConst.tableActionHeader
        ],
        base: [
          { text: 'Claimant', align: 'left', value: 'clmtNo' },
          { text: 'Item No.', align: 'left', value: 'clmItem' },
          { text: 'Reserve Category', align: 'left', value: 'clmResCat' },
          { text: 'Status', align: 'left', value: 'status' },
          { text: 'Outstanding Reserve (Local)', align: 'right', value: 'clmResLocOS' },
          { text: 'Planned to Pay (Local)', align: 'right', value: 'plannedLoc' },
          { text: 'Already Paid (Local)', align: 'right', value: 'paidLoc' },
          TableConst.tableActionHeader
        ]
      },
      activeHeaders: [],
      nol1Loading: false,
      nol2Loading: false,
      loading: false,
      claimItemList: [],
      clmtAndItem: '',
      clmtAndItemDesc: '',
      svcClmtAndItem: '',
      svcClmtAndItemDesc: '',
      totPaid: 0,
      newClm: false,
      showClaimItemHelpList: false,
      showServicerGroupHelpList: false,
      showServicerHelpList: false,
      showCurrHelpList: false,
      showClaimReserveHelpList: false,
      clmtItemType: '',
      interGrpName: '',
      interName: '',
      clmResCatDesc: '',
      authTxt: '',
      promptAuth: false,
      promptCaptureAuth: false,
      usrClmLim: true,
      promptCaptureAuthDel: false,
      adjResTxt: "Reserve Adjustment has exceeded user's Limit",
      authApproveTxt: 'User Not Authorised to Approve Transaction',
      firstEnterScreen: true,
      promptAdjResTxt: false,
      promptFlag: false,
      promptAuthApproveTxt: false,
      tableKey: 0,
      promptPendingPayment: false,
      pendingReserve: false,
      promptPendingReserve: false,
      promptPendingReserveTxt: 'There is a claim reserve pending authorisation. Please proceed to authorise',
      displayAccumRes: [],
      promptPendingPaymentTxt: 'There is a claim payment pending authorisation. Please proceed to claim payment screen to authorise',
      reverseOverLimitList: [],
      ableToAddReserve: true,
      promptEditOrgRes: false,
      promptEditOrgResTxt: 'Please edit the original reserve.'
    }
  },
  watch: {
    displayCurr: function(value) {
      this.activeHeaders = this.reserveHeaders[value] || []
    },
    reserveCurr: function(value) {
      if (value) {
        this.displayCurr = 'res'
      } else {
        this.displayCurr = 'base'
      }
    }
  },
  computed: {
    selectedClaimant() {
      return this.$store.state.claims.claimDetail.selectedClaimant || {}
    },
    tranDate() {
      return this.$store.state.claims.claimDetail.tranDate || new Date()
    },
    selectedClmItem() {
      return this.$store.state.claims.claimDetail.selectedClmItem || {}
    },
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    currencyList() {
      return this.$store.state.claims.claimParams.currencyList
    },
    reserveList() {
      return this.$store.state.claims.claimParams.reservesList
    },
    selectedClaimantClmtName() {
      if (this.selectedClaimant.clmtName) {
        return this.selectedClaimant.clmtName
      } else {
        return 'Claimant'
      }
    },
    selectedClaimantClmtNo() {
      if (this.selectedClaimant.clmtNo) {
        return (this.selectedClaimant.clmtNo + '').padStart(3, '0')
      } else {
        return '000'
      }
    },
    selectedClmItemNo() {
      if (this.selectedClmItem.clmItem) {
        return (this.selectedClmItem.clmItem + '').padStart(5, '0')
      } else {
        return '0'
      }
    },
    submitReserves() {
      return this.$store.state.claims.claimDetail.commonInfo.submitReserves
    },
    servicers() {
      return this.$store.state.claims.claimDetail.commonInfo.servicers
    },
    clmAccumRes() {
      return this.$store.state.claims.claimDetail.commonInfo.clmAccumRes
    },
    totAccumRes() {
      return this.$store.state.claims.claimDetail.commonInfo.totAccumRes
    },
    totPlannedRes() {
      return this.$store.state.claims.claimDetail.commonInfo.totPlannedRes
    },
    totPaidRes() {
      return this.$store.state.claims.claimDetail.commonInfo.totPaidRes
    },
    totAccumResLoc() {
      return this.$store.state.claims.claimDetail.commonInfo.totAccumResLoc
    },
    totPlannedLoc() {
      return this.$store.state.claims.claimDetail.commonInfo.totPlannedLoc
    },
    totPaidLoc() {
      return this.$store.state.claims.claimDetail.commonInfo.totPaidLoc
    },
    promptFlagRes() {
      return this.$store.state.claims.clmPendExistList.promptFlagRes
    },
    reserveOverLimitList() {
      return this.$store.state.claims.clmPendExistList.reserveOverLimitList
    },
    promptFlagPay() {
      return this.$store.state.claims.clmPendExistList.promptFlagPay
    },
    paymentOverLimitList() {
      return this.$store.state.claims.clmPendExistList.paymentOverLimitList
    }
  },
  mounted() {
    // Check claim lifecycle (might be using back link or url)
    if (this.$store.state.claims.claimDetail.claimLifeCycle !== 5) {
      this.$store.commit(CLAIMS_LIFECYCLE, 5)
    }
    this.doInit()
    this.activeHeaders = this.reserveHeaders[this.displayCurr]
  },
  methods: {
    async doPrintClaimFaceSheet() {
      try {
        let msg = await this.$store.dispatch('printClaimFaceSheet')
        if (msg !== '') {
          this.promptPrntClmFcSht = true
          this.msgPrntClmFcSht = msg
        }
        this.doUpdateClmStatus()
      } catch (err) {
        return false
      }
    },
    async doUpdateClmStatus() {
      let req = {
        clmNo: this.commonInfo.clmNo,
        cStatBef: this.$store.state.claims.claimDetail.commonInfo.cStatBef,
        cStatAft: this.commonInfo.clmStat,
        ddOldRes: this.$store.state.claims.claimDetail.commonInfo.ddOldRes,
        ddNewRes: this.commonInfo.planPaytLoc + this.commonInfo.totResLoc
      }
      const apiUrl = this.$store.state.claims.claimDetail.menu.updateClmRiHdr
      if (apiUrl) {
        try {
          await this.$http.post(apiUrl, req)
        } catch (err) {
          return false
        }
      }
    },
    async doBack() {
      this.$store.commit(CLAIMS_LIFECYCLE, 4)
      this.$router.push({ name: 'claimItem', params: { navFlag: 1 } })
    },
    activateRow(row) {
      this.selectedRecord = row.item.clmtNo + '-' + row.item.clmItem + '-' + row.item.clmResCat
      this.selectedRow = row
    },
    async doExit() {
      this.doUpdateClmStatus()
      if (this.promptFlagRes || this.promptFlagPay) {
        if (this.promptFlagRes) {
          this.promptAdjResTxt = true
        }
      }
      this.$router.push({ name: 'mngClaim' })
    },
    doExitClaim() {
      this.$root.$emit('leaveClaim')
      this.$router.push({ name: 'mngClaim' })
      this.doUpdateClmStatus()
    },
    toggleCurr() {
      if (this.displayCurr === 'res') {
        this.displayCurr = 'base'
      } else if (this.displayCurr === 'base') {
        this.displayCurr = 'res'
      }
    },
    async doQuickPay() {
      if (this.selectedRow.item !== '' && this.selectedRow.item !== undefined) {
        this.loading = true
        // let isClear = await this.getPendingAuthorisation('C001')
        // let isClear = await this.getPendingAuthorisation('C003')
        // if (isClear) {
        //   isClear = await this.getPendingAuthorisation('C003')
        // }
        // this.loading = false
        // if (!isClear) {
        //   this.$toast.error('There is a pending Claims Limit Authorisation request for this claim (70370)')
        //   return
        // }
        this.doPay(this.selectedRow)
        let data = {}
        for (const claimant of this.commonInfo.claimants) {
          if (claimant.clmtNo === this.selectedRow.item.clmtNo) {
            data.selectedClaimant = claimant
            this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMANT, data)
            data = {}
            if (claimant.clmItems) {
              for (const claimItem of claimant.clmItems) {
                if (claimItem.clmItem === this.selectedRow.item.clmItem) {
                  data.selectedClmItem = claimItem
                  this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMITEM, data)
                  const selectedReserves = []
                  selectedReserves.push(this.selectedRow.item)
                  const resData = {
                    selectedReserves: selectedReserves,
                    resCurr: this.commonInfo.resCurr
                  }
                  this.$store.commit(CLAIMS_CLAIMPAYMENT_SELECTEDRESERVES, resData)
                }
              }
            }
          }
        }
        this.$store.commit(CLAIMS_LIFECYCLE, 6)
        this.$router.push({ name: 'claimPaymentList' })
      } else {
        this.$toast.warning('Please select claim reserve to proceed.')
      }
    },
    doPay(event) {
      const selectedReserves = []
      selectedReserves.push(event.item)
      const data = {
        selectedReserves: selectedReserves,
        resCurr: this.selectedClmItem.resCurr
      }
      this.$store.commit(CLAIMS_CLAIMPAYMENT_SELECTEDRESERVES, data)
      this.$router.push({ name: 'claimPaymentList' })
    },
    getParamReserve(key) {
      for (let paramReserve of this.reserveList) {
        if (paramReserve.value === key) {
          return paramReserve
        }
      }
      return {}
    },
    async doInit() {
      this.doAuthPendClmStatus()
      this.promptAuth = false
      this.promptCaptureAuth = false
      this.promptCaptureAuthDel = false
      this.usrClmLim = true
      this.commonInfo.submitReserves = []
      this.commonInfo.servicers = []

      // If navFlag is 1, it is trigger from stepper
      // if (this.$route.params.navFlag === 1 || this.selectedClaimantClmtNo === 'undefined') {
      if (this.commonInfo.claimants) {
        for (const claimant of this.commonInfo.claimants) {
          if (claimant.clmItems) {
            for (const claimItem of claimant.clmItems) {
              if (claimItem.servicers) {
                for (const servicer of claimItem.servicers) {
                  servicer.clmtNo = claimItem.clmtNo
                  servicer.clmItem = claimItem.clmItem
                  this.commonInfo.servicers.push(servicer)
                }
              }
              if (claimItem.clmItemReserves) {
                for (const claimItemReserve of claimItem.clmItemReserves) {
                  this.commonInfo.submitReserves.push(claimItemReserve)
                }
              }
            }
          }
        }
      } else {
        this.commonInfo.submitReserves = []
        this.commonInfo.clmAccumRes = []
        this.commonInfo.servicers = []
      }
      await this.$store.dispatch('commonsInit').then(() => {
        this.getClaimantList()
        this.getClaimItemList()
      })
      let filteredAccumRes = []
      let rawData = JSON.parse(JSON.stringify(this.commonInfo.clmAccumRes || []))
      for (let res of rawData) {
        if (res.status === 'P') {
          let existP = filteredAccumRes.find(x =>
            x.clmtNo === res.clmtNo &&
            x.clmItem === res.clmItem &&
            x.clmResCat === res.clmResCat &&
            x.status === 'P'
          )
          if (existP) {
            existP.clmResOS = parseFloat(removeFormatNumber(existP.clmResOS || 0)) + parseFloat(removeFormatNumber(res.clmResOS || 0))
            existP.clmResOSLoc = parseFloat(removeFormatNumber(existP.clmResOSLoc || 0)) + parseFloat(removeFormatNumber(res.clmResOSLoc || 0))
            continue
          }
        } else {
          res.clmResOS = parseFloat(removeFormatNumber(res.clmResOS || 0))
          res.clmResOSLoc = parseFloat(removeFormatNumber(res.clmResOSLoc || 0))
        }
        filteredAccumRes.push(res)
      }
      this.displayAccumRes = filteredAccumRes
      // calculate totals
      this.commonInfo.totAccumRes = 0
      this.commonInfo.totPlanned = 0
      this.commonInfo.totPlannedLoc = 0
      this.commonInfo.totPlannedRes = 0
      this.commonInfo.totAccumResLoc = 0
      this.totPaid = 0
      this.commonInfo.totPaidLoc = 0
      this.commonInfo.totPaidRes = 0
      // AR: Added Number and isNaN checks
      // JJ: Multiply by 100s in calculation to avoid floating point calculation problems
      for (let res of this.commonInfo.clmAccumRes) {
        if (res.status !== 'P') {
          this.commonInfo.totAccumRes = this.commonInfo.totAccumRes + Number(removeFormatNumber(res.clmResOS)) * 100
          this.commonInfo.totAccumResLoc = this.commonInfo.totAccumResLoc + Number(removeFormatNumber(res.clmResOSLoc)) * 100
          this.commonInfo.totPlanned = this.commonInfo.totPlanned + Number(removeFormatNumber(res.planned)) * 100
          this.commonInfo.totPlannedLoc = this.commonInfo.totPlannedLoc + Number(removeFormatNumber(res.plannedLoc)) * 100
          this.commonInfo.totPlannedRes = this.commonInfo.totPlannedRes + Number(removeFormatNumber(res.plannedRes)) * 100
          this.totPaid = this.totPaid + Number(removeFormatNumber(res.paid)) * 100
          this.commonInfo.totPaidLoc = this.commonInfo.totPaidLoc + Number(removeFormatNumber(res.paidLoc)) * 100
          this.commonInfo.totPaidRes = this.commonInfo.totPaidRes + Number(removeFormatNumber(res.paidRes)) * 100
        }
      }
      // normalize
      this.commonInfo.totAccumRes = isNaN(this.commonInfo.totAccumRes) ? 0 : this.commonInfo.totAccumRes / 100
      this.commonInfo.totPlanned = isNaN(this.commonInfo.totPlanned) ? 0 : this.commonInfo.totPlanned / 100
      this.commonInfo.totPlannedLoc = isNaN(this.commonInfo.totPlannedLoc) ? 0 : this.commonInfo.totPlannedLoc / 100
      this.commonInfo.totPlannedRes = isNaN(this.commonInfo.totPlannedRes) ? 0 : this.commonInfo.totPlannedRes / 100
      this.commonInfo.totAccumResLoc = isNaN(this.commonInfo.totAccumResLoc) ? 0 : this.commonInfo.totAccumResLoc / 100
      this.totPaid = isNaN(this.totPaid) ? 0 : this.totPaid / 100
      this.commonInfo.totPaidRes = isNaN(this.commonInfo.totPaidRes) ? 0 : this.commonInfo.totPaidRes / 100
      this.commonInfo.totPaidLoc = isNaN(this.commonInfo.totPaidLoc) ? 0 : this.commonInfo.totPaidLoc / 100
      if (this.$store.state.claims.claimDetail.commonInfo.clmStat === 'newClm') {
        this.newClm = true
      }
      if (this.firstEnterScreen === true) {
        await this.checkUsrClmLim().then((x) => {
          this.doPromptAuth(x)
        })
      }
    },
    getClaimantDesc(key) {
      for (let clmt of this.claimantList) {
        if (clmt.value === key) {
          return clmt.label
        }
      }
      return ''
    },
    async doSaveClaimReserve() {
      try {
        const clmResCatSplit = this.selectedReserve.clmResCat.split(' - ')
        this.selectedReserve.clmResCat = clmResCatSplit[0]
        this.promptFlag = await this.$store.dispatch('saveClaimReserve', this.selectedReserve)
        if (this.promptFlag) {
          const copyOfReserve = JSON.parse(JSON.stringify(this.selectedReserve))
          this.$store.commit('UPDATE_CLM_PEND_EXIST_LIST', {
            promptFlagRes: true,
            reserveOverLimit: copyOfReserve
          })
        }
        // this.firstEnterScreen = false
        return true
      } catch (err) {
        return false
      }
    },
    async doSaveClaimServicer() {
      try {
        const currSplit = this.selectedServicer.curr.split(' - ')
        this.selectedServicer.curr = currSplit[0]
        const interSplit = this.selectedServicer.inter.split(' - ')
        this.selectedServicer.inter = interSplit[0]
        const interGrpSplit = this.selectedServicer.interGrp.split(' - ')
        this.selectedServicer.interGrp = interGrpSplit[0]
        await this.$store.dispatch('saveClaimServicer', this.selectedServicer)
        return true
      } catch (err) {
        return false
      }
    },
    resetServicer() {
      this.resetMessages()
      this.resetValidator()
      this.servicer.interGrp = undefined
      this.servicer.inter = undefined
      this.servicer.curr = undefined
      this.servicer.amt = undefined
      this.servicer.locAmt = undefined
    },
    closeServicer() {
      this.newServicer = false
      this.servicerDialog = false
      this.resetServicer()
    },
    addServicer() {
      this.newServicer = true
      this.servicerDialog = true
      this.servicerLayer = true
      this.resetServicer()
      if (this.claimItemList && this.claimItemList.length > 0) {
        this.svcClmtAndItem = this.claimItemList[0].value
        this.svcClmtAndItemDesc = this.claimItemList[0].label
      }
    },
    saveServicer() {
      this.$validator
        .validateAll('servicer')
        .then(result => {
          if (result) {
            if (this.newServicer) {
              /* AR: Get the values from the dropdown list
            this.selectedServicer.clmNo = this.selectedClmItem.clmNo
            this.selectedServicer.clmtNo = this.selectedClmItem.clmtNo
            this.selectedServicer.clmItem = this.selectedClmItem.clmItem
            */
              let arrClmtItem = this.svcClmtAndItem.split(';')
              this.selectedServicer.clmNo = this.commonInfo.clmNo
              this.selectedServicer.clmtNo = arrClmtItem[0]
              this.selectedServicer.clmItem = arrClmtItem[1]
              // this.selectedServicer.inter = this.getParamServicer(this.servicer.inter).value
              this.selectedServicer.inter = this.servicer.inter
              // this.selectedServicer.interName = this.getParamServicer(this.servicer.inter).label
              this.selectedServicer.interGrp = this.servicer.interGrp
              this.selectedServicer.curr = this.servicer.curr
              this.selectedServicer.amt = removeFormatNumber(this.servicer.amt)
              this.selectedServicer.locAmt = 0.0
            } else {
              this.selectedServicer.curr = this.servicer.curr
              this.selectedServicer.amt = removeFormatNumber(this.servicer.amt)
              this.selectedServicer.locAmt = 0.0
            }
            return true
          } else {
            // validation occur
            this.promptFieldCheck()
            return false
          }
        })
        .then(result => {
          if (result) {
            // save to server
            this.doSaveClaimServicer().then(result2 => {
              if (result2) {
                this.firstEnterScreen = false
                this.doInit()
                this.closeServicer()
              }
            })
          }
        })
    },
    doAdjustServicer(row) {
      this.svcClmtAndItemDesc = this.getClaimantDesc(row.item.clmtNo)
      this.svcClmtAndItem = row.item.clmtNo + ';' + row.item.clmItem
      this.selectedServicer = row.item
      this.servicer.interGrp = this.selectedServicer.interGrp
      this.interGrpName = this.selectedServicer.interGrpName
      this.servicer.inter = this.selectedServicer.inter
      this.interName = this.selectedServicer.interName
      this.servicer.curr = this.selectedServicer.curr + ' - ' + this.selectedServicer.currDesc
      this.servicer.amt = this.formatDisplayNumber(this.selectedServicer.amt, 2)
      this.servicer.locAmt = this.selectedServicer.locAmt
      this.newServicer = false
      this.servicerDialog = true
      this.servicerLayer = true
    },
    doPromptRemoveServicer(row) {
      this.servicerRemove = row.item
      this.promptRemoveServicer = true
    },
    async doRemoveServicer() {
      this.removeClaimServicer().then(result => {
        if (result) {
          this.firstEnterScreen = false
          this.doInit()
        }
      })
    },
    async removeClaimServicer() {
      try {
        await this.$store.dispatch('removeClaimServicer', this.servicerRemove)
        return true
      } catch (err) {
        return false
      }
    },
    doGetReserve() {
      this.$store.dispatch('claimReserves', { busCls: this.commonInfo.busCls })
    },
    resetReserve() {
      this.resetMessages()
      this.resetValidator()
      this.reserve.clmResCat = undefined
      this.reserve.reserve = undefined
      this.reserve.reserveLoc = undefined
      this.reserve.acctMth = undefined
      this.reserve.acctYr = undefined
      this.reserve.totRes = undefined
    },
    closeReserve() {
      this.newReserve = false
      this.reserveDialog = false
      this.resetReserve()
    },
    async checkUsrClmLimPayt() {
      try {
        const apiUrl = this.$store.state.commons.menu.checkUsrClmLimPayt
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo,
            busCls: this.commonInfo.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          return result.data.data
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async addReserve() {
      if (this.pendingReserve) {
        this.promptPendingReserve = true
        this.reserveDialog = false
        this.firstEnterScreen = true
      } else {
        this.promptPendingReserve = false
        await this.checkUsrClmLimPayt().then((x) => {
          if (x.result === true) {
            this.promptPendingPayment = true
          } else {
            this.promptPendingPayment = false
            this.newReserve = true
            this.reserveDialog = true
            this.reserveLayer = true
            this.resetReserve()
            if (this.claimItemList && this.claimItemList.length > 0) {
              this.clmtAndItem = this.claimItemList[0].value
              this.clmtAndItemDesc = this.claimItemList[0].label
            }
          }
        })
      }
    },
    saveReserve() {
      this.resetMessages()
      this.$validator
        .validateAll('itemReserve')
        .then(result => {
          if (result) {
            this.selectedReserve.clmResCat = this.reserve.clmResCat
            /* AR: Get the values from the dropdown list
          this.selectedReserve.clmNo = this.selectedClmItem.clmNo
          this.selectedReserve.clmtNo = this.selectedClmItem.clmtNo
          this.selectedReserve.clmItem = this.selectedClmItem.clmItem
          */
            let arrClmtItem = this.clmtAndItem.split(';')
            this.selectedReserve.clmNo = this.commonInfo.clmNo
            this.selectedReserve.clmtNo = arrClmtItem[0]
            this.selectedReserve.clmItem = arrClmtItem[1]
            this.selectedReserve.tranDate = this.tranDate
            this.selectedReserve.reserve = this.reserve.reserve
            this.selectedReserve.totRes = this.reserve.totRes
            this.selectedReserve.newReserve = this.newReserve
            this.$store.commit(CLAIMS_CLAIMDETAIL_RESERVES, this.commonInfo)
            return true
          } else {
            this.promptFieldCheck()
            return false
          }
        })
        .then(result => {
          if (result) {
            // save to server
            this.doSaveClaimReserve().then(result2 => {
              if (result2) {
                this.closeReserve()
                this.firstEnterScreen = false
                this.doInit()
              }
            })
          }
        })
    },
    doPromptRemoveReserve(row) {
      this.reserveRemove = row.item
      this.promptRemoveReserve = true
    },
    doRemoveReserve() {
      this.doRemoveClaimReserve().then(result => {
        if (result) {
          this.firstEnterScreen = false
          this.doInit()
        }
      })
    },
    async doRemoveClaimReserve() {
      try {
        /* AR: Replaced by values from the reserve from the list 16Nov2020
        this.reserveRemove.clmNo = this.selectedClmItem.clmNo
        this.reserveRemove.clmtNo = this.selectedClmItem.clmtNo
        this.reserveRemove.clmItem = this.selectedClmItem.clmItem
        */
        this.reserveRemove.clmNo = this.commonInfo.clmNo
        await this.$store.dispatch('removeClaimReserve', this.reserveRemove)
        return true
      } catch (err) {
        return false
      }
    },
    async doAdjustReserve(row) {
      if (this.pendingReserve) {
        this.promptPendingReserve = true
        this.reserveDialog = false
        this.firstEnterScreen = true
      } else if (row.item.status === 'P') {
        this.promptEditOrgRes = true
      } else {
        this.promptPendingReserve = false
        await this.checkUsrClmLimPayt().then((x) => {
          if (x.result === true) {
            this.promptPendingPayment = true
          } else {
            this.promptPendingPayment = false
            this.resetReserve()
            this.newReserve = false
            this.clmtAndItemDesc = this.getClaimantDesc(row.item.clmtNo)
            this.clmtAndItem = row.item.clmtNo + ';' + row.item.clmItem
            this.reserve.clmResCat = row.item.clmResCat
            this.clmResCatDesc = row.item.clmResCatDesc
            this.reserve.reserve = row.item.clmResOS
            this.reserve.totRes = row.item.totRes
            this.reserveDialog = true
          }
        })
      }
    },
    formatDisplayNumber(val) {
      return formatDisplayNumber(val)
    },
    async getClaimantList() {
      const apiUrl = this.$store.state.commons.menu.claimantList
      if (apiUrl) {
        const expand = {
          claimNo: this.commonInfo.clmNo
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        if (result.data.dataList) {
          this.$set(this, 'claimantList', result.data.dataList)
        } else {
          this.claimantList = []
        }
      }
    },
    async getClaimItemList() {
      const apiUrl = this.$store.state.commons.menu.claimItemList
      if (apiUrl) {
        const expand = {
          claimNo: this.commonInfo.clmNo
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        if (result.data.dataList) {
          this.$set(this, 'claimItemList', result.data.dataList)
        } else {
          this.claimItemList = []
        }
      }
    },
    async getPendingAuthorisation(taskId) {
      try {
        const apiUrl = this.$store.state.commons.menu.pendingAuthorisation
        if (apiUrl) {
          const expand = {
            modId: 2,
            taskId: taskId,
            clmNo: this.commonInfo.clmNo,
            polNo: '',
            renCnt: 0,
            endtCnt: 0,
            docNo: this.commonInfo.docNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          return result.data.data.result
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async checkUsrClmLim() {
      try {
        const apiUrl = this.$store.state.commons.menu.checkUsrClmLimRes
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo,
            busCls: this.commonInfo.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          return result.data.data
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async doDelPendClmRes() {
      try {
        const apiUrl = this.$store.state.commons.menu.delPendClmRes
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          this.firstEnterScreen = false
          const clmResCat = result.data.data.clmResCat
          this.commonInfo.clmAccumRes = this.commonInfo.clmAccumRes.filter(item => {
            return !(item.clmResCat === clmResCat || item.status === 'P')
          })
          this.commonInfo.clmReses = this.commonInfo.clmReses.filter(item => {
            return !(item.clmResCat === clmResCat || item.status === 'P')
          })
          this.doInit()
          this.refreshTable()
          this.pendingReserve = false
          return result
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    refreshTable() {
      this.tableKey++
    },
    async doAuthPendClmRes(action) {
      try {
        const apiUrl = this.$store.state.commons.menu.authPendClmRes
        if (apiUrl) {
          const expand = {
            clmNo: this.commonInfo.clmNo,
            busCls: this.commonInfo.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.data.result === true) {
            if (action === 'Approve') {
              this.promptCaptureAuth = true
              this.promptCaptureAuthDel = false
            } else if (action === 'Reject') {
              this.promptCaptureAuth = false
              this.promptCaptureAuthDel = true
            }
          } else {
            this.usrClmLim = false
            this.promptAuthApproveTxt = true
          }
          return result.data.data.result
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.notify(err.response.data)
        }
      }
    },
    async validDelPassword() {
      this.promptCaptureAuthDel = true
    },
    async closePopOut() {
      this.promptAuth = false
      this.pendingReserve = true
      this.firstEnterScreen = true
    },
    async updateAfterAuth() {
      let reserveAmt
      let reserveAmtLoc
      this.commonInfo.clmReses.forEach(item => {
        if (item.status === 'P') {
          item.status = ''
          reserveAmt = item.reserve
          reserveAmtLoc = item.reserveLoc
        }
      })
      let itemTemp
      let exist = false
      this.commonInfo.clmAccumRes.forEach(item => {
        if (item.status === 'P') {
          itemTemp = item
        }
      })
      this.commonInfo.clmAccumRes.forEach(item => {
        if (item.clmResCat === itemTemp.clmResCat && item.status !== 'P') {
          exist = true
        }
      })
      if (exist === false) {
        this.commonInfo.clmAccumRes.forEach(item => {
          if (item.clmResCat === itemTemp.clmResCat && item.status === 'P') {
            item.status = ''
          }
        })
      } else {
        this.commonInfo.clmAccumRes = this.commonInfo.clmAccumRes.filter(item => {
          return !(item.clmResCat === itemTemp.clmResCat && item.status === 'P')
        })
        this.commonInfo.clmAccumRes.filter(item => {
          if (item.clmResCat === itemTemp.clmResCat) {
            item.status = ''
            item.totRes = parseFloat(removeFormatNumber(item.totRes)) + parseFloat(removeFormatNumber(itemTemp.totRes))
            item.totResLoc = parseFloat(removeFormatNumber(item.totResLoc)) + parseFloat(removeFormatNumber(itemTemp.totResLoc))
            item.clmResOS = parseFloat(removeFormatNumber(item.clmResOS)) + parseFloat(removeFormatNumber(itemTemp.clmResOS))
            item.clmResOSLoc = parseFloat(removeFormatNumber(item.clmResOSLoc)) + parseFloat(removeFormatNumber(itemTemp.clmResOSLoc))
          }
        })
      }
      this.commonInfo.totAccumRes = this.commonInfo.totAccumRes + parseFloat(removeFormatNumber(reserveAmt))
      this.commonInfo.totAccumResLoc = this.commonInfo.totAccumResLoc + parseFloat(removeFormatNumber(reserveAmtLoc))
      this.$store.state.claims.clmHasRIOrResAdj.hasRIOrResAdj = true
    },
    async updateAfterAuth1() {
      this.pendingReserve = false
      let totalReserveAmt = 0
      let totalReserveAmtLoc = 0
      this.commonInfo.clmReses.forEach(item => {
        if (item.status === 'P') {
          item.status = ''
          totalReserveAmt += parseFloat(removeFormatNumber(item.reserve || 0))
          totalReserveAmtLoc += parseFloat(removeFormatNumber(item.reserveLoc || 0))
        }
      })
      const pendingItems = this.commonInfo.clmAccumRes.filter(item => item.status === 'P')
      if (pendingItems.length > 0) {
        const pendingMap = {}
        pendingItems.forEach(item => {
          const uniqueKey = `${item.clmtNo}_${item.clmItem}_${item.clmResCat}}`
          if (!pendingMap[uniqueKey]) {
            pendingMap[uniqueKey] = {
              ...item,
              totRes: 0,
              totResLoc: 0,
              clmResOS: 0,
              clmResOSLoc: 0
            }
          }
          pendingMap[uniqueKey].totRes += parseFloat(removeFormatNumber(item.totRes || 0))
          pendingMap[uniqueKey].totResLoc += parseFloat(removeFormatNumber(item.totResLoc || 0))
          pendingMap[uniqueKey].clmResOS += parseFloat(removeFormatNumber(item.clmResOS || 0))
          pendingMap[uniqueKey].clmResOSLoc += parseFloat(removeFormatNumber(item.clmResOSLoc || 0))
        })
        let activeAccumRes = this.commonInfo.clmAccumRes.filter(item => item.status !== 'P')
        Object.keys(pendingMap).forEach(cat => {
          const mergedPendingItem = pendingMap[cat]
          const existItem = activeAccumRes.find(item => item.clmResCat === cat)
          if (existItem) {
            existItem.totRes = parseFloat(removeFormatNumber(existItem.totRes || 0)) + mergedPendingItem.totRes
            existItem.totResLoc = parseFloat(removeFormatNumber(existItem.totResLoc || 0)) + mergedPendingItem.totResLoc
            existItem.clmResOS = parseFloat(removeFormatNumber(existItem.clmResOS || 0)) + mergedPendingItem.clmResOS
            existItem.clmResOSLoc = parseFloat(removeFormatNumber(existItem.clmResOSLoc || 0)) + mergedPendingItem.clmResOSLoc
            existItem.status = ''
          } else {
            mergedPendingItem.status = ''
            activeAccumRes.push(mergedPendingItem)
          }
        })
        this.commonInfo.clmAccumRes = activeAccumRes
      }
      this.commonInfo.totAccumRes = parseFloat(removeFormatNumber(this.commonInfo.totAccumRes || 0)) + totalReserveAmt
      this.commonInfo.totAccumResLoc = parseFloat(removeFormatNumber(this.commonInfo.totAccumResLoc || 0)) + totalReserveAmtLoc
      this.$store.state.claims.clmHasRIOrResAdj.hasRIOrResAdj = true
      this.doInit()
      this.refreshTable()
    },
    async doAuthPendClmStatus() {
      let apiUrl = this.$store.state.commons.menu.getPendClmAll
      if (apiUrl) {
        const expand = {
          clmNo: this.commonInfo.clmNo
        }
        this.$http.get(expandURI(apiUrl, expand)).then(async result => {
          const data = result.data
          if (data.data.result3 === true) {
            this.usrClmLim = false
          }
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.$toast.error(data.messages[0].message)
          }
        })
      }
    },
    doAssign(field, data) {
      switch (field) {
        case 'claimItem':
          if (this.clmtItemType === 'svcClaimItem') {
            this.svcClmtAndItem = data.value
            this.svcClmtAndItemDesc = data.label
          } else {
            this.clmtAndItem = data.value
            this.clmtAndItemDesc = data.label
          }
          break
        case 'interGrp':
          this.servicer.interGrp = data
          break
        case 'inter':
          this.servicer.inter = data.label
          this.servicer.interGrp = data.secondaryValue
          break
        case 'clmRes':
          this.reserve.clmResCat = data
          break
        case 'curr':
          this.servicer.curr = data.curr + ' - ' + data.currDesc
          break
      }
    },
    getHelpList(field) {
      switch (field) {
        case 'svcClaimItem':
        case 'claimItem':
          this.clmtItemType = field
          this.showClaimItemHelpList = true
          break
        case 'interGrp':
          this.showServicerGroupHelpList = true
          break
        case 'inter':
          this.showServicerHelpList = true
          break
        case 'clmRes':
          this.showClaimReserveHelpList = true
          break
        case 'curr':
          this.showCurrHelpList = true
          break
      }
    },
    async doPromptAuth(data) {
      if (data.result === true && data.pendList) {
        let authContent = 'There is a claim reserve pending authorisation:\n'
        for (const item of data.pendList) {
          authContent += `- (${item.clmtNo}, ${item.clmItem}, ${item.clmResCat}, SGD ${formatDisplayNumber(item.reserveLoc, 2)})\n`
        }
        authContent += 'Proceed to authorise?'
        this.authTxt = authContent
        this.promptAuth = true
        this.pendingReserve = true
        this.firstEnterScreen = false
      }
    },
    async doCloseEnterPassword() {
      this.promptCaptureAuth = false
      this.promptCaptureAuthDel = false
      this.pendingReserve = false
      this.promptAuth = true
    }
  },
  created() {
    this.$validator.extend('res_amt_pne', {
      getMessage(field, args) {
        if (args === void 0) args = []
        var resAmtPNE = args[0]
        if (resAmtPNE) {
          if (resAmtPNE === 'P') {
            // Value must be Positive
            return `${field} value must be Positive.`
          } else if (resAmtPNE === 'N') {
            // Value must be Positive
            return `${field} value must be Negative.`
          } else {
            return ''
          }
        } else {
          return ''
        }
      },
      validate(value, args) {
        if (value) {
          value = '' + value // If a format other den str, it doesnt has replace
          const valueWithoutMask = value.replace(/,/g, '')
          if (args === void 0) args = []
          var resAmtPNE = args[0]
          if (resAmtPNE) {
            if (resAmtPNE === 'P') {
              return valueWithoutMask > 0
              // if (valueWithoutMask < 0) {
              //   return false
              // } else {
              //   return true
              // }
            } else if (resAmtPNE === 'N') {
              return valueWithoutMask < 0
              // if (valueWithoutMask > 0) {
              //   return false
              // } else {
              //   return true
              // }
            } else return true
          } else return true
        } else return true
      }
    })
  },
  components: {
    ReserveTrackList,
    ServicerGroupHelpList,
    ServicerHelpList,
    CurrencyHelpList,
    ClaimItemHelpList,
    ClaimReserveHelpList,
    ConfirmAuth,
    CaptureAuth
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>

<style lang="scss">
.activeRow {
  background-color: #fff9c4ff;
}
</style>
